import { UserAuditLogEntry } from 'apis/auditLogs';

import { CardField, UserActivityCard } from './userActivityCard';
import { humanize, statusColors } from './userActivityTypes.utils';

type UserBannedProps = {
  entry: UserAuditLogEntry<'USER_BANNED'>;
};

export const UserBanned = ({ entry }: UserBannedProps): JSX.Element => {
  const channels = entry.channel_ref.map(humanize).join(', ');
  const fields: CardField[] = [
    { label: 'Reason', value: entry.reason },
    {
      label: 'Expires',
      value: entry.expected_end_time
        ? new Date(entry.expected_end_time).toLocaleString()
        : undefined,
    },
    {
      label: 'IP address',
      value: entry.ip_address,
      copyText: entry.ip_address,
    },
  ].filter((field) => field.value);

  return (
    <UserActivityCard
      entry={entry}
      icon="user-slash"
      color={statusColors.negative}
      title="Banned"
      summary={channels || undefined}
      fields={fields}
    />
  );
};
